<template>
  
</template>

<script>
import { MAHADEMY_APP_ENV } from '@/components/common/constants.js'
import axios from 'axios'
export default {
  name: 'mahademyHome',
  data () {
    return {
      token: ''
    }
  },
  created () {
    if (this.$route.params.token !== 'none') {
      this.token = this.$route.params.token
      localStorage.setItem('ssoToken', false)
      localStorage.setItem('token', this.token)
      localStorage.setItem('isLoggedIn', true)
    }
    localStorage.setItem('app_env', MAHADEMY_APP_ENV)
    if (localStorage.getItem('token') !== null) {
      this.handleLogin()
    }
  },
  methods: {
    handleLogin () {
      axios.get('/o/loginForSocialUser', null, {headers: {'Authorization': localStorage.getItem('mahademyToken')}})
      .then(res => {
        this.$store.dispatch('setUserStoreData', res.data).then(res => {
          this.$router.replace({path: '/home'})
        })
      }).catch(err => {
        console.log('error occured in redirection: ', err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mahademyHome.vue?46c72bd3